import React__default from 'react';
import insertPlaceholders from './c6b120029a0d68cdac623667364adbe08c7cc29dfccb25ae23b4426e244ea261.cfe-internal.js';
import useTranslation from './de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import containsComponentOrElement from './f2144ef5f2fc57057e816a3021b4e50eddc22ceb77d5c54423c430dba969d1e5.cfe-internal.js';

/**
 * Gets the translated version of the given key.
 *
 * @param messageKey - The key to target from locale.
 * @param placeholders - A map of parameters to replace in the translated string. The string is searched for each key in the map wrapped by {{}} and then replaced with the corresponding value. If the value is a component, it must specify a key.
 * @return An array of components if `placeholders` contains a component. Otherwise a translated string.
 *
 * @example
 *
 *     const translations = {
 *         pagination: '{{currentPage}} of {{numPages}}'
 *     }
 *
 *     <Translate
 *         messageKey="pagination"
 *         placeholders={{ currentPage: 2, numPages: 5 }}
 *     />
 *
 *     Result:
 *
 *     '2 of 5'
 *
 * @example
 *
 *     const translations = {
 *         pagination: '{{currentPage}} of {{numPages}}'
 *     }
 *
 *     <Translate
 *         messageKey="pagination"
 *         placeholders={{
 *             currentPage: <span key="currentPage">2</span>,
 *             numPages: 5
 *         }}
 *     />
 *
 *     Result:
 *
 *     [<span>2</span>, ' of ', '5']
 */
var Translate = function Translate(_ref) {
  var messageKey = _ref.messageKey,
    placeholders = _ref.placeholders;
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  var text = translate(messageKey);
  if (placeholders) {
    var compiledMessage = insertPlaceholders(text, placeholders);
    if (containsComponentOrElement(placeholders)) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, insertPlaceholders(text, placeholders));
    }
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, compiledMessage.join(''));
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, text);
};

export { Translate as default };
